import React from 'react';

import type { Section } from '../../../../../models';
import { NATURAL_GAS, UTILITY_CALCULATION_LISTBOX_OPTIONS } from '../../../../../constants';
import UtilitiesCalculation from '../../Utilities/UtilitiesCalculation/UtilitiesCalculation';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function NaturalGasCalculation({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesCalculation
      section={section}
      setSectionValues={setSectionValues}
      administrativeFeeField={NATURAL_GAS.FIELD_NAME.ADMINSTRATIVE_FEE}
      listBoxField={NATURAL_GAS.FIELD_NAME.FIXED_AMOUNT_CALCULATION}
      otherMethodDescriptionField={NATURAL_GAS.FIELD_NAME.OTHER_METHOD_DESCRIPTION}
      otherMethodField={NATURAL_GAS.FIELD_NAME.OTHER_METHOD}
      options={UTILITY_CALCULATION_LISTBOX_OPTIONS}
      utilityName="Natural gas"
    />
  );
}

NaturalGasCalculation.description =
  'Additional options for how they calculated and whether or not there an additional fee';

export default NaturalGasCalculation;
